







































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import { redirectToGear3Login } from '@/utils/gear3Redirect';

@Component({
  name: 'LoginUpgradeDialog',
})
export default class LoginUpgradeDialog extends Vue {
  @Prop({ default: false }) public readonly visible!: boolean;

  public countdown = 10;
  public countdownTimer: number | null = null;
  public redirecting = false;

  get noticeRows() {
    return [
      {
        en: this.$t('login.upgradeNoticeLine2En') as string,
        zh: this.$t('login.upgradeNoticeLine2Zh') as string,
      },
      {
        en: this.$t('login.upgradeNoticeLine3En') as string,
        zh: this.$t('login.upgradeNoticeLine3Zh') as string,
      },
    ];
  }

  get transferButtonTextZh() {
    return this.$t('login.transferToNewPlatformZh') as string;

  }

  get transferButtonTextEn() {
    return this.$t('login.transferToNewPlatform', { seconds: this.countdown }) as string;
  }

  @Watch('visible', { immediate: true })
  public onVisibleChange(value: boolean) {
    if (value) {
      this.redirecting = false;
      this.startCountdown();
      return;
    }
    this.clearCountdown();
    this.countdown = 10;
    this.redirecting = false;
  }

  public beforeDestroy() {
    this.clearCountdown();
  }

  public handleContinueLogin() {
    this.clearCountdown();
    this.$emit('update:visible', false);
  }

  public handleTransferNow() {
    if (this.redirecting) {
      return;
    }
    this.redirecting = true;
    this.clearCountdown();
    this.$emit('update:visible', false);
    redirectToGear3Login('');
  }

  private startCountdown() {
    this.clearCountdown();
    this.countdown = 10;
    this.countdownTimer = window.setInterval(() => {
      if (this.countdown <= 1) {
        this.handleTransferNow();
        return;
      }
      this.countdown -= 1;
    }, 1000);
  }

  private clearCountdown() {
    if (this.countdownTimer !== null) {
      window.clearInterval(this.countdownTimer);
      this.countdownTimer = null;
    }
  }
}
